export function showAccountNumber(bankDetails) {
  if (bankDetails.iban) {
    return I18n.t('components.billing.invoices.bank_account_details.iban', {
      iban: bankDetails.iban,
    });
  }

  return I18n.t('components.billing.invoices.bank_account_details.account_number', {
    number: bankDetails.accountNumber,
  });
}

export function showCode(bankDetails) {
  if (bankDetails.bic) {
    return I18n.t('components.billing.invoices.bank_account_details.bic', {
      bic: bankDetails.bic,
    });
  }

  return I18n.t('components.billing.invoices.bank_account_details.sort_code', {
    sort_code: bankDetails.sortCode,
  });
}
